import type { Lead } from '../../../shared/types';
import { durablePoint } from '../../../shared/locationRepair';
import type { LeadLocation } from '../logic/followupRoute';
import type { LatLng } from '../logic/route';

export type Locatable = Pick<Lead, 'id' | 'address'> & Partial<Lead>;
/** Select durable coordinates; rendering never triggers a billable lookup. */
export const leadLocations = (leads: readonly Locatable[]): Map<string, LeadLocation> => new Map(
  leads.flatMap((lead) => {
    const at = durablePoint(lead);
    return at ? [[lead.id, { ...at, address: lead.address, ...(lead.place_id ? { place_id: lead.place_id } : {}) }] as const] : [];
  }),
);
export const locateLeads = async (leads: readonly Locatable[]): Promise<Map<string, LeadLocation>> => leadLocations(leads);

/** The phone's position to start the route from; null when denied, unavailable or too slow
 *  (including a permission prompt left unanswered). */
export const currentPosition = (timeoutMs = 8000): Promise<LatLng | null> =>
  new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      resolve(null);
      return;
    }
    const timer = setTimeout(() => resolve(null), timeoutMs + 2000);
    navigator.geolocation.getCurrentPosition(
      (p) => {
        clearTimeout(timer);
        resolve({ lat: p.coords.latitude, lng: p.coords.longitude });
      },
      () => {
        clearTimeout(timer);
        resolve(null);
      },
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 120_000 },
    );
  });
